import type { AssetVizTheme } from '@asset-viz/types/providers'

/**
 * Sensible dark-mode defaults derived from the forecast app's ForecastDarkTheme.
 * These values allow AssetViz to render without a wrapping AssetVizThemeProvider.
 */
export const defaultTheme: AssetVizTheme = {
  activeText: 'rgba(250, 250, 250, 1)',
  background1: 'rgba(0, 0, 0, 1)',
  background2: 'rgba(17, 17, 17, 1)',
  background2_5: 'rgba(34, 34, 34, 1)',
  background3: 'rgba(51, 51, 51, 1)',
  defaultText: 'rgba(229, 229, 229, 1)',
  secondaryText: 'rgba(163, 163, 163, 1)',
  border: 'rgba(51, 51, 51, 1)',
  icon1: 'rgba(255, 255, 255, 1)',
}
